import ApiError from 'utils/api/errors/ApiError';


class ApiNotFoundError extends ApiError {
  constructor (props) {
    super(props);
    this.name = 'ApiNotFoundError';
  }
}

export default ApiNotFoundError;
